export default __webpack_public_path__ + "static/round-91c9fd6d8b4ad95e3c968276936368a6.png";